/* eslint-disable */
// @ts-nocheck
export function initHeroSampleBreakdown() {
  var PROFILES = {
    assembly: { Materials: 66.6, Labor: 15.3, Overhead: 9.3, 'Value Add': 8.8 },
    material: { Materials: 84, Labor: 8, Overhead: 5, 'Value Add': 3 },
  }
  var COLORS = {
    Materials: '#f59e0b',
    Labor: '#fbbf24',
    Overhead: '#fcd34d',
    'Value Add': '#fde68a',
  }
  var ORDER = ['Materials', 'Labor', 'Overhead', 'Value Add']
  var card = document.getElementById('mi-bd')
  if (!card) return

  var OFFSET = 12

  function money(v) {
    if (!v) return '0'
    return window.formatQuantity(v)
  }
  function render(node) {
    var pct = (node.cost / (node.rootCost || node.cost)) * 100
    var head = (pct >= 99.95 ? '100.0' : pct.toFixed(1)) + '% of product total'
    var rows = ORDER.map(function (k) {
      var v
      if (node.breakdown) {
        v = node.breakdown[k]
        if (v == null || v <= 0) return ''
      } else {
        var prof = PROFILES[node.profile] || PROFILES.material
        v = (node.cost * prof[k]) / 100
        if (!v || v <= 0) return ''
      }
      return (
        '<div class="mi-bd__row"><span class="mi-bd__dot" style="background:' +
        COLORS[k] +
        '"></span>' +
        '<span class="mi-bd__name">' +
        k +
        '</span><span class="mi-bd__amt">$' +
        money(v) +
        ' <i>USD</i></span></div>'
      )
    }).join('')
    card.innerHTML = '<div class="mi-bd__head">' + head + '</div>' + rows
  }
  function positionAt(x, y) {
    var w = card.offsetWidth || 234,
      h = card.offsetHeight || 150
    var left = x + OFFSET,
      top = y + OFFSET
    if (left + w > window.innerWidth - 8) left = x - w - OFFSET
    if (left < 8) left = 8
    if (top + h > window.innerHeight - 8) top = y - h - OFFSET
    if (top < 8) top = 8
    card.style.left = left + 'px'
    card.style.top = top + 'px'
  }
  function show(node, x, y) {
    render(node)
    card.classList.add('is-open')
    positionAt(x, y)
  }
  function hide() {
    card.classList.remove('is-open')
  }

  document.querySelectorAll('.mi-bom--table').forEach(function (table) {
    table.querySelectorAll('.mi-row[data-i]').forEach(function (row) {
      row.addEventListener('mouseenter', function (e) {
        var node = (window.MI_NODES || {})[row.getAttribute('data-i')]
        if (node) show(node, e.clientX, e.clientY)
      })
      row.addEventListener('mousemove', function (e) {
        if (!card.classList.contains('is-open')) return
        positionAt(e.clientX, e.clientY)
      })
      row.addEventListener('mouseleave', hide)
    })
  })
  window.addEventListener('scroll', hide, true)
  window.addEventListener('resize', hide)
}
